var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLendingIntelligence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 33,
    viewBox: "0 0 121 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3097_13277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3223 11.7586C17.3223 11.7586 18.8189 14.6153 15.1213 16.8181L19.0936 18.1992C19.0936 18.1992 17.5371 14.6362 20.548 12.7831L17.3223 11.7551V11.7586Z",
    fill: "url(#paint0_linear_3097_13277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7733 8.39849C18.7733 8.39849 16.0018 9.2831 15.1214 6.15723L12.4028 10.0104C12.4028 10.0104 16.1075 9.16072 17.3224 11.7621L18.7733 8.39849Z",
    fill: "url(#paint1_linear_3097_13277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5224 9.98599C12.5224 9.98599 8.61706 10.6293 9.02203 14.2762L4.52856 10.3217C4.52856 10.3217 8.14165 10.486 8.46563 6.56641L12.5224 9.98599Z",
    fill: "url(#paint2_linear_3097_13277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8183 10.0594C13.6698 10.0594 15.1708 8.56915 15.1708 6.73077C15.1708 4.8924 13.6698 3.4021 11.8183 3.4021C9.96678 3.4021 8.46582 4.8924 8.46582 6.73077C8.46582 8.56915 9.96678 10.0594 11.8183 10.0594Z",
    fill: "#030304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4529 13.049C20.7735 13.049 21.844 11.9861 21.844 10.6749C21.844 9.36371 20.7735 8.30078 19.4529 8.30078C18.1323 8.30078 17.0618 9.36371 17.0618 10.6749C17.0618 11.9861 18.1323 13.049 19.4529 13.049Z",
    fill: "#030304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1812 16.0139C13.1812 16.0139 12.0191 16.6502 10.8746 16.3391C10.2548 16.1712 9.28285 15.6223 9.01873 14.2761L4.91968 19.2936C4.91968 19.2936 9.05043 18.6223 10.2618 22.7901L13.1812 16.0104V16.0139Z",
    fill: "url(#paint3_linear_3097_13277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52516 19.3112C7.02434 19.3112 9.05032 17.2996 9.05032 14.8182C9.05032 12.3368 7.02434 10.3252 4.52516 10.3252C2.02598 10.3252 0 12.3368 0 14.8182C0 17.2996 2.02598 19.3112 4.52516 19.3112Z",
    fill: "#030304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9419 27.0526C19.2015 27.0526 21.844 24.4289 21.844 21.1924C21.844 17.956 19.2015 15.3323 15.9419 15.3323C12.6822 15.3323 10.0398 17.956 10.0398 21.1924C10.0398 24.4289 12.6822 27.0526 15.9419 27.0526Z",
    fill: "#030304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3567 4.15735C70.913 4.15735 70.5045 4.03148 70.1523 3.8147V13.0699H72.5611V3.8147C72.2124 4.03148 71.8004 4.15735 71.3567 4.15735Z",
    fill: "#030304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3566 3.26224C72.1248 3.26224 72.7476 2.64389 72.7476 1.88112C72.7476 1.11835 72.1248 0.5 71.3566 0.5C70.5884 0.5 69.9656 1.11835 69.9656 1.88112C69.9656 2.64389 70.5884 3.26224 71.3566 3.26224Z",
    fill: "#030304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3567 20.2797C70.913 20.2797 70.5045 20.1538 70.1523 19.937V29.1923H72.5611V19.937C72.2124 20.1538 71.8004 20.2797 71.3567 20.2797Z",
    fill: "#030304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3566 19.3846C72.1248 19.3846 72.7476 18.7662 72.7476 18.0034C72.7476 17.2407 72.1248 16.6223 71.3566 16.6223C70.5884 16.6223 69.9656 17.2407 69.9656 18.0034C69.9656 18.7662 70.5884 19.3846 71.3566 19.3846Z",
    fill: "#030304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2545 13.07H32.5635V1.25879H35.0532V11.0245H40.2545V13.07Z",
    fill: "#030304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2485 10.3846C48.9844 12.1049 47.4032 13.2587 45.2164 13.2587C42.4942 13.2587 40.8638 11.5315 40.8638 8.72378C40.8638 5.91609 42.5118 4.1084 45.1248 4.1084C47.7378 4.1084 49.3225 5.83567 49.3225 8.5035V9.23078H43.2302V9.37763C43.2302 10.6294 44.0296 11.4895 45.2586 11.4895C46.139 11.4895 46.8151 11.056 47.0405 10.3846H49.2485ZM43.2549 7.76574H47.0053C46.956 6.64336 46.2235 5.87413 45.1495 5.87413C44.0754 5.87413 43.3359 6.66784 43.2549 7.76574Z",
    fill: "#030304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.495 4.29715H52.8192V5.86009H52.8685C53.3368 4.77267 54.2701 4.13281 55.6294 4.13281C57.5909 4.13281 58.6966 5.36009 58.6966 7.41603V13.0734H56.2879V7.91603C56.2879 6.76918 55.742 6.11533 54.6645 6.11533C53.5869 6.11533 52.9002 6.90204 52.9002 8.03841V13.0734H50.4915V4.29715H50.495Z",
    fill: "#030304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7319 8.66788C59.7319 5.88466 61.1335 4.15739 63.3521 4.15739C64.6304 4.15739 65.6199 4.82872 66.0496 5.80424H66.0989V1.25879H68.5076V13.07H66.1341V11.563H66.0918C65.6622 12.528 64.6409 13.2098 63.338 13.2098C61.13 13.2098 59.7355 11.4756 59.7355 8.66788H59.7319ZM62.197 8.68536C62.197 10.2973 62.94 11.2868 64.1515 11.2868C65.3629 11.2868 66.1129 10.2868 66.1129 8.68536C66.1129 7.08396 65.3452 6.07347 64.1515 6.07347C62.9577 6.07347 62.197 7.08047 62.197 8.68536Z",
    fill: "#030304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2054 4.29715H76.5296V5.86009H76.5789C77.0473 4.77267 77.9805 4.13281 79.3398 4.13281C81.3013 4.13281 82.4071 5.36009 82.4071 7.41603V13.0734H79.9983V7.91603C79.9983 6.76918 79.4525 6.11533 78.3749 6.11533C77.2973 6.11533 76.6106 6.90204 76.6106 8.03841V13.0734H74.2019V4.29715H74.2054Z",
    fill: "#030304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6361 13.6922H85.9956C86.1857 14.2971 86.8795 14.7062 87.7916 14.7062C89.0382 14.7062 89.7284 14.0279 89.7284 13.0104V11.4719H89.6791C89.2671 12.4055 88.2282 13.0453 86.9499 13.0453C84.7912 13.0453 83.365 11.3915 83.365 8.65023C83.365 5.90897 84.749 4.15723 86.9922 4.15723C88.2634 4.15723 89.26 4.82156 89.7213 5.82856H89.7636V4.29709H92.1371V12.9509C92.1371 15.0383 90.3728 16.381 87.7246 16.381C85.4004 16.381 83.8263 15.2586 83.6361 13.6957V13.6922ZM89.7354 8.66772C89.7354 7.0873 88.9677 6.07331 87.7634 6.07331C86.559 6.07331 85.8265 7.07331 85.8265 8.66772C85.8265 10.2621 86.5696 11.2062 87.7634 11.2062C88.9572 11.2062 89.7354 10.2551 89.7354 8.66772Z",
    fill: "#030304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5635 29.1958V17.3811H35.0532V29.1923H32.5635V29.1958Z",
    fill: "#030304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8246 20.4195H39.1488V21.9824H39.1981C39.6664 20.895 40.5996 20.2551 41.959 20.2551C43.9204 20.2551 45.0262 21.4824 45.0262 23.5383V29.1957H42.6175V24.0383C42.6175 22.8915 42.0716 22.2376 40.9941 22.2376C39.9165 22.2376 39.2298 23.0244 39.2298 24.1607V29.1957H36.821V20.4195H36.8246Z",
    fill: "#030304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6147 18.3985V20.4195H51.2487V22.2202H49.6147V26.4195C49.6147 27.0908 49.9457 27.409 50.6536 27.409C50.8684 27.409 51.0902 27.3915 51.2381 27.367V29.1258C50.9916 29.1817 50.5796 29.2237 50.0936 29.2237C48.0159 29.2237 47.2095 28.5349 47.2095 26.8251V22.2167H45.9629V20.416H47.2095V18.395H49.6182L49.6147 18.3985Z",
    fill: "#030304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4609 26.5106C60.1968 28.2309 58.6156 29.3847 56.4288 29.3847C53.7066 29.3847 52.0762 27.6575 52.0762 24.8498C52.0762 22.0421 53.7242 20.2344 56.3372 20.2344C58.9502 20.2344 60.5349 21.9616 60.5349 24.6295V25.3568H54.4426V25.5036C54.4426 26.7554 55.242 27.6155 56.471 27.6155C57.3514 27.6155 58.0275 27.1819 58.2529 26.5106H60.4609ZM54.4673 23.8917H58.2177C58.1684 22.7693 57.4359 22.0001 56.3619 22.0001C55.2878 22.0001 54.5483 22.7938 54.4673 23.8917Z",
    fill: "#030304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0562 17.3811H64.4649V29.1923H62.0562V17.3811Z",
    fill: "#030304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0955 17.3811H68.5042V29.1923H66.0955V17.3811Z",
    fill: "#030304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9098 29.8147H76.2693C76.4594 30.4196 77.1532 30.8287 78.0652 30.8287C79.3118 30.8287 80.0021 30.1504 80.0021 29.1329V27.5945H79.9528C79.5407 28.528 78.5019 29.1679 77.2236 29.1679C75.0649 29.1679 73.6387 27.5141 73.6387 24.7728C73.6387 22.0315 75.0226 20.2798 77.2658 20.2798C78.5371 20.2798 79.5337 20.9441 79.995 21.9511H80.0373V20.4196H82.4108V29.0735C82.4108 31.1609 80.6465 32.5036 77.9983 32.5036C75.6741 32.5036 74.1 31.3812 73.9098 29.8182V29.8147ZM80.0091 24.7903C80.0091 23.2099 79.2414 22.1959 78.0371 22.1959C76.8327 22.1959 76.1002 23.1959 76.1002 24.7903C76.1002 26.3847 76.8433 27.3287 78.0371 27.3287C79.2309 27.3287 80.0091 26.3777 80.0091 24.7903Z",
    fill: "#030304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0632 26.5106C91.7991 28.2309 90.2179 29.3847 88.0311 29.3847C85.3089 29.3847 83.6785 27.6575 83.6785 24.8498C83.6785 22.0421 85.3265 20.2344 87.9395 20.2344C90.5525 20.2344 92.1372 21.9616 92.1372 24.6295V25.3568H86.0449V25.5036C86.0449 26.7554 86.8443 27.6155 88.0733 27.6155C88.9537 27.6155 89.6298 27.1819 89.8552 26.5106H92.0632ZM86.0696 23.8917H89.82C89.7707 22.7693 89.0382 22.0001 87.9642 22.0001C86.8901 22.0001 86.1506 22.7938 86.0696 23.8917Z",
    fill: "#030304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3556 20.4195H95.6798V21.9824H95.7291C96.1974 20.895 97.1306 20.2551 98.49 20.2551C100.451 20.2551 101.557 21.4824 101.557 23.5383V29.1957H99.1485V24.0383C99.1485 22.8915 98.6026 22.2376 97.5251 22.2376C96.4475 22.2376 95.7608 23.0244 95.7608 24.1607V29.1957H93.3521V20.4195H93.3556Z",
    fill: "#030304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.78 23.6853C108.639 22.7587 108.023 22.1048 107.033 22.1048C105.847 22.1048 105.104 23.1048 105.104 24.7971C105.104 26.4895 105.847 27.5069 107.04 27.5069C108.005 27.5069 108.632 26.9335 108.78 25.9755H111.023C110.9 28.0454 109.34 29.3811 107.016 29.3811C104.353 29.3811 102.663 27.6608 102.663 24.7971C102.663 21.9335 104.353 20.2307 106.998 20.2307C109.389 20.2307 110.907 21.6957 111.013 23.6853H108.78Z",
    fill: "#030304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.246 26.5106C119.982 28.2309 118.401 29.3847 116.214 29.3847C113.492 29.3847 111.861 27.6575 111.861 24.8498C111.861 22.0421 113.509 20.2344 116.122 20.2344C118.735 20.2344 120.32 21.9616 120.32 24.6295V25.3568H114.228V25.5036C114.228 26.7554 115.027 27.6155 116.256 27.6155C117.137 27.6155 117.813 27.1819 118.038 26.5106H120.246ZM114.252 23.8917H118.003C117.954 22.7693 117.221 22.0001 116.147 22.0001C115.073 22.0001 114.333 22.7938 114.252 23.8917Z",
    fill: "#030304"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3097_13277",
    x1: 15.1213,
    y1: 14.9824,
    x2: 20.548,
    y2: 14.9824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3097_13277",
    x1: 12.4028,
    y1: 8.95793,
    x2: 18.7733,
    y2: 8.95793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3097_13277",
    x1: 4.52504,
    y1: 10.423,
    x2: 12.5224,
    y2: 10.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3097_13277",
    x1: 4.9232,
    y1: 18.5349,
    x2: 13.1812,
    y2: 18.5349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3097_13277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120.32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLendingIntelligence);
export default __webpack_public_path__ + "static/media/logo_lending_intelligence.f6959d6b098675ca7629a9790620b7ac.svg";
export { ForwardRef as ReactComponent };